import {getUserID} from "modules/selectors/user";
import {IGlobalStore} from "modules/types";
import {createSelector} from "reselect";

export const getTeamStore = (store: IGlobalStore) => store.herds;

export const getTeamError = createSelector(
	[getTeamStore],
	({team_error}) => team_error
)

export const isTeamExists = createSelector(
	[getTeamStore],
	({team}) => !!team
)

export const getTeam = createSelector(
	[getTeamStore],
	({team}) => team
)

export const isVisibleCaptainModal = createSelector(
	[getTeamStore],
	({show_captains_modal}) => show_captains_modal
)

export const isVisibleNewCaptainModal = createSelector(
	[getTeamStore],
	({show_new_captain_modal}) => show_new_captain_modal
)

export const isVisibleInviteCaptainModal = createSelector(
	[getTeamStore],
	({show_invite_captain_modal}) => show_invite_captain_modal
)

export const isRequestedTeam = createSelector(
	[getTeamStore],
	({is_requested}) => is_requested
)

export const isUserCaptain = createSelector(
	[getTeamStore, getUserID],
	({team}, user_id) => team?.captain_id === user_id
)
